import React, { useState, useEffect } from 'react';
import SearchIcon from '@rsuite/icons/Search';
import debounce from 'lodash/debounce';
import PlusIcon from '@rsuite/icons/Plus';
import { Container, Stack, Table, InputGroup } from 'rsuite';
import api from '../../services/api';
import { NotificationContainer } from 'react-notifications';
import EditarCadastrarEntregador from './EditarCadastrar';
import RedefinirSenha from './RedefinirSenha';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomButton } from '../../components/CustomButton';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomInput } from '../../components/CustomInput';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { FaMotorcycle } from 'react-icons/fa';

const { Column } = Table;

const Entregadores = () => {
  const { id_empresa } = useAuth();
  const [buscar, setBuscar] = useState('');
  const [loading, setLoading] = useState(true);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [entregadores, setEntregadores] = useState([]);
  const [entregador, setEntregador] = useState(null);
  const [open, setOpen] = useState(false);
  const [openSenha, setOpenSenha] = useState(false);
  const { theme } = useCustomTheme();

  const atualizar = async () => {
    await api
      .get(`entregador/listar/${id_empresa}`)
      .then((res) => {
        if (res.data.length > 0) {
          setEntregadores(res.data);
        } else {
          setEntregadores([]);
        }
      })
      .then(() => {
        setLoading(false);
      });
  };

  const consultar = async (consulta) => {
    consulta = consulta.substring(4);
    if (consulta === '') {
      atualizar();
    } else {
      await api
        .post('entregador/listarPorNomeGestor', {
          IdEmpresa: id_empresa,
          Consulta: consulta,
        })
        .then((res) => {
          res.data.length > 0 ? setEntregadores(res.data) : setEntregadores([]);
        })
        .then(() => {
          setLoading(false);
        });
    }
  };

  const cadastrar = () => {
    setEntregador(null);
    setOpen(true);
  };

  const abrirDados = (ent) => {
    setEntregador(ent);
    setOpen(true);
  };

  const redefinir = (ent) => {
    setEntregador(ent);
    setOpenSenha(true);
  };

  const dataAtivos = [
    { label: 'Ver todos', value: '' },
    { label: 'Filtrar: Ativos', value: '0' },
    { label: 'Filtrar: Inativos', value: '-1' },
  ];

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao += filtroStatus !== '' ? ` AND Ativo='${filtroStatus}'` : ``;
    instrucao += value_lower ? ` AND LOWER(Nome) LIKE '%${value_lower}%'` : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 1000);

  useEffect(() => {
    atualizar();
  }, []);

  useEffect(() => {
    debounceSearch(buscar ?? '');
  }, [filtroStatus]);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Entregadores"
        subtitle="Gerencie os entregadores da sua empresa"
        icon={FaMotorcycle}
        style={{ zIndex: 0 }}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <Stack spacing={10}>
            <CustomSelectPicker
              data={dataAtivos}
              defaultValue={'Ativos'}
              value={filtroStatus}
              onChange={(value) => setFiltroStatus(value)}
              style={{ width: 140 }}
              searchable={false}
            />
            <CustomButton appearance="primary" onClick={() => cadastrar()}>
              <PlusIcon style={{ marginRight: 6 }} /> Cadastrar
            </CustomButton>
            <DuvidasButton tela="entregador" />
          </Stack>
        }
      />
      <Table
        height={window.innerHeight - 60 - 90}
        autoHeight
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        bordered={true}
        loading={loading}
        data={entregadores}
        width={'100%'}
        onRowClick={(rowData) => {
          console.log(rowData);
        }}
        locale={{
          emptyMessage: 'Nenhum entregador encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={100}
          align="center"
          fixed
        >
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Nome</CustomHeaderCell>
          <CustomCell dataKey="Nome" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Celular</CustomHeaderCell>
          <CustomCell dataKey="Celular" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={150}
          fixed="right"
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>

          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                {rowData.Ativo ? (
                  <CustomButton
                    appearance="ghost"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => {}}
                  >
                    {' '}
                    Sim{' '}
                  </CustomButton>
                ) : (
                  <CustomButton
                    appearance="primary"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      width: 50,
                    }}
                    onClick={() => {}}
                  >
                    {' '}
                    Não{' '}
                  </CustomButton>
                )}
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          width={150}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>

          <CustomCell>
            {(rowData) => (
              <>
                <span>
                  <CustomButton
                    color={theme.colors.warning}
                    appearance="ghost"
                    size="xs"
                    onClick={() => abrirDados(rowData)}
                  >
                    {' '}
                    Editar{' '}
                  </CustomButton>
                  {' | '}
                </span>
                <span>
                  <CustomButton
                    onClick={() => redefinir(rowData)}
                    color="red"
                    appearance="ghost"
                    size="xs"
                  >
                    {' '}
                    Redefinir{' '}
                  </CustomButton>
                </span>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>
      {open && (
        <EditarCadastrarEntregador
          modal={open}
          refresh={atualizar}
          close={() => setOpen(false)}
          IdEmpresa={id_empresa}
          entregador={entregador}
          setEntregadores={setEntregadores}
        />
      )}
      {openSenha && (
        <RedefinirSenha
          modal={openSenha}
          close={() => setOpenSenha(false)}
          entregador={entregador}
        />
      )}
      <NotificationContainer />
    </Container>
  );
};

export default Entregadores;
